export default __webpack_public_path__ + "static/media/cushion-box.65280123.svg";